import React, { useMemo } from 'react'
import { Button, Icon } from 'gu-ui-kit'
import styles from 'modules/Tickets/List/subcomponents/Row/subcomponents/StatusIcon/status-icon.module.scss'
import PropTypes from 'prop-types'

const STATUS_MAP = {
  opened: {
    icon: 'time-clock',
    color: 'Label-GU-Primary',
    bgColor: 'Background-Fifth',
    label: 'tickets::list.statuses.pending',
  },
  pending: {
    icon: 'time-clock',
    color: 'Accent-Notice-Primary',
    bgColor: 'Background-Notice',
    label: 'tickets::list.statuses.pending',
  },
  working: {
    icon: 'time-clock',
    color: 'Label-GU-Primary',
    bgColor: 'Background-Fifth',
    label: 'tickets::list.statuses.pending',
  },
  closed: {
    icon: 'check',
    color: 'Interface-Eighth',
    bgColor: 'Background-Fifth',
    label: 'tickets::list.statuses.pending',
  },
}

const StatusIcon = ({ status, counter }) => {
  const iconProps = useMemo(() => STATUS_MAP[status], [status])

  return (
    <div className={styles['container']}>
      <Button
        noLabel
        bgColor={iconProps.bgColor}
        noHover
        size={'m'}
        startIcon={
          <Icon name={iconProps.icon} size={'m'} color={iconProps.color} />
        }
      />
      {counter > 0 && (
        <span className={styles['unread-counter']}>{counter}</span>
      )}
    </div>
  )
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(['opened', 'pending', 'working', 'closed']),
  counter: PropTypes.number,
}

export default StatusIcon
